export default "/images/vendor/flag-icon-css/flags/1x1/lv.svg?2ce7f836390f846b1359abaa9ba4e8bc";